import React from "react";

function ProductCatalog() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 11.7188V22.957L11.25 23.332L1.5 18.4688V6.28125L11.25 1.40625L21 6.28125V15H19.5V7.96875L12 11.7188ZM11.25 3.09375L8.42578 4.5L15.7031 8.17969L18.5742 6.75L11.25 3.09375ZM10.5 21.2812V11.7188L3 7.96875V17.5312L10.5 21.2812ZM3.92578 6.75L11.25 10.4062L14.0391 9.02344L6.75 5.34375L3.92578 6.75ZM16.5 21V19.5H24V21H16.5ZM16.5 16.5H24V18H16.5V16.5ZM13.5 24V22.5H15V24H13.5ZM13.5 18V16.5H15V18H13.5ZM13.5 21V19.5H15V21H13.5ZM16.5 24V22.5H24V24H16.5Z"
        fill="#424242"
      />
    </svg>
  );
}

export default ProductCatalog;
